<section class="max-w-[1320px] mx-auto px-6 lg:px-10 pt-8 pb-16 relative z-10 animate-fade-in">

  <!-- Top Stats -->
  <div class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 mb-10 pb-4 border-b border-white/5">
    <div *ngFor="let stat of topStats" class="relative group">
      <!-- Glow effect -->
      <div class="absolute -inset-[1px] bg-gradient-to-r from-white/5 to-white/0 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-500 blur-[2px]"></div>
      
      <div class="relative flex flex-col p-5 rounded-2xl bg-[#0c0c0c]/80 border border-white/5 group-hover:border-white/10 group-hover:bg-[#111] transition-all duration-300 h-full overflow-hidden">
        <!-- Subtle internal glow based on positive/negative -->
        <div class="absolute -top-10 -right-10 w-24 h-24 rounded-full blur-2xl opacity-10" [ngClass]="stat.isPositive ? 'bg-emerald-500' : 'bg-red-500'"></div>
        
        <div class="text-text-muted text-[12px] font-bold uppercase tracking-wider mb-2 relative z-10">{{stat.title}}</div>
        <div class="text-white font-black text-[22px] tracking-tight mb-2 relative z-10">{{stat.value}}</div>
        <div class="text-[11.5px] font-bold flex items-center gap-1.5 mt-auto relative z-10" [ngClass]="stat.isPositive ? 'text-emerald-400' : 'text-red-400'" *ngIf="stat.change !== 0">
          <div class="p-0.5 rounded-full" [ngClass]="stat.isPositive ? 'bg-emerald-400/10' : 'bg-red-400/10'">
            <svg class="w-2.5 h-2.5" *ngIf="stat.isPositive" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="3"><path stroke-linecap="round" stroke-linejoin="round" d="M5 15l7-7 7 7" /></svg>
            <svg class="w-2.5 h-2.5" *ngIf="!stat.isPositive" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="3"><path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" /></svg>
          </div>
          {{stat.change > 0 ? stat.change : -stat.change}}% today
        </div>
      </div>
    </div>
  </div>
  
  <div class="mt-6 mb-8 p-4 rounded-xl bg-gold/10 border border-gold/30 flex items-start gap-3">
    <svg class="w-5 h-5 text-gold flex-shrink-0 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
      <path stroke-linecap="round" stroke-linejoin="round" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
    </svg>
    <p class="text-white text-[13.5px] leading-relaxed">
      <span class="font-bold text-gold">Important Note:</span> All new tokens are listed here with their contract address and put into pools with WETH in the pool section. Contact us to have your token created, listed and become a crypto bank.
    </p>
  </div>

  <!-- Header & Controls -->
  <div class="flex flex-col md:flex-row md:items-center justify-between mb-6 gap-4">
    <div class="flex items-center gap-6">
      <button (click)="setTab('Tokens')" [ngClass]="activeTab === 'Tokens' ? 'text-white' : 'text-text-muted hover:text-white'" class="text-[20px] font-black tracking-wide transition-colors">Tokens</button>
      <button (click)="setTab('Pools')" [ngClass]="activeTab === 'Pools' ? 'text-white' : 'text-text-muted hover:text-white'" class="text-[20px] font-black tracking-wide transition-colors">Pools</button>
      <button (click)="setTab('Transactions')" [ngClass]="activeTab === 'Transactions' ? 'text-white' : 'text-text-muted hover:text-white'" class="text-[20px] font-black tracking-wide transition-colors">Transactions</button>
    </div>
    <div class="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 w-full md:w-auto">
      
      <!-- Search -->
      <div class="relative w-full sm:w-auto mt-1 sm:mt-0" *ngIf="activeTab !== 'Transactions'">
        <svg class="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-text-muted pointer-events-none" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"/></svg>
        <input type="text" placeholder="Search..." [(ngModel)]="searchQuery" (ngModelChange)="onSearchChange()" class="bg-[#050505] border border-white/10 rounded-xl pl-9 pr-4 py-2 text-[12px] text-white placeholder-text-dim outline-none focus:border-gold/30 w-full sm:w-[140px] transition-colors font-bold">
      </div>
      
    </div>
  </div>

  <!-- Table -->
  <div class="card rounded-[20px] bg-[#0c0c0c]/90 border border-white/[0.08] backdrop-blur-xl shadow-xl p-4 lg:p-0 overflow-hidden">
    <div class="overflow-x-auto w-full">
    
    <!-- TOKENS TAB -->
    <table class="w-full text-left border-collapse min-w-[1000px]" *ngIf="activeTab === 'Tokens'">
      <thead>
        <tr class="text-text-muted text-[11px] font-bold uppercase tracking-wider border-b border-white/5">
          <th class="py-4 px-4 cursor-pointer hover:text-white transition-colors" (click)="sortBy('token')">
            <div class="flex items-center gap-1">Token</div>
          </th>
          <th class="py-4 px-4 cursor-pointer hover:text-white transition-colors">Contract Address</th>
          <th class="py-4 px-4 text-right cursor-pointer hover:text-white transition-colors">Price</th>
          <th class="py-4 px-4 text-right cursor-pointer hover:text-white transition-colors">1H</th>
          <th class="py-4 px-4 text-right cursor-pointer hover:text-white transition-colors">1D</th>
          <th class="py-4 px-4 text-right cursor-pointer hover:text-white transition-colors">FDV</th>
          <th class="py-4 px-4 text-right cursor-pointer hover:text-white transition-colors">Volume</th>
        </tr>
      </thead>
      <tbody class="text-sm">
        <tr *ngFor="let token of tokens; let i = index" class="border-b border-white/5 hover:bg-white/[0.04] transition-colors">
          <td class="py-4 px-4 whitespace-nowrap">
            <div class="flex items-center gap-3 pl-2">
              <img *ngIf="token.logoUrl" [src]="token.logoUrl" class="w-7 h-7 rounded-full object-cover border border-white/10" [alt]="token.symbol" />
              <div *ngIf="!token.logoUrl" class="w-7 h-7 rounded-full flex items-center justify-center font-black text-white text-[9px] relative overflow-hidden bg-white/10 border border-white/20">
                {{token.symbol.substring(0, 1)}}
              </div>
              <div class="flex items-baseline gap-1.5">
                <span class="text-white font-black text-[13.5px]">{{token.name}}</span>
                <span class="text-text-muted text-[11px] font-bold">{{token.symbol}}</span>
              </div>
            </div>
          </td>
          <td class="py-4 px-4 whitespace-nowrap">
            <div *ngIf="token.address" class="flex items-center gap-2">
              <span class="text-text-muted font-mono text-[12px]">{{token.address.substring(0, 6)}}...{{token.address.substring(token.address.length - 4)}}</span>
              <button (click)="copyToClipboard(token.address, $event)" class="text-text-dim hover:text-white transition-colors p-1" title="Copy Address">
                <svg class="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 0 002 2z" />
                </svg>
              </button>
            </div>
            <div *ngIf="!token.address" class="text-text-muted text-[12px] italic">N/A</div>
          </td>
          <td class="py-4 px-4 text-right font-bold text-[13px] whitespace-nowrap">
            <span>${{token.priceUsd < 0.1 ? (token.priceUsd | number:'1.5-5') : (token.priceUsd | number:'1.2-4')}}</span>
          </td>
          <td class="py-4 px-4 text-right font-bold text-[12.5px] whitespace-nowrap" [ngClass]="token.priceChange1h >= 0 ? 'text-emerald-400' : 'text-red-400'">
            <span class="flex items-center justify-end gap-1">
              <svg class="w-2.5 h-2.5" *ngIf="token.priceChange1h >= 0" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="3"><path stroke-linecap="round" stroke-linejoin="round" d="M5 15l7-7 7 7" /></svg>
              <svg class="w-2.5 h-2.5" *ngIf="token.priceChange1h < 0" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="3"><path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" /></svg>
              {{token.priceChange1h >= 0 ? token.priceChange1h : -token.priceChange1h | number:'1.2-2'}}%
            </span>
          </td>
          <td class="py-4 px-4 text-right font-bold text-[12.5px] whitespace-nowrap" [ngClass]="token.priceChange1d >= 0 ? 'text-emerald-400' : 'text-red-400'">
            <span class="flex items-center justify-end gap-1">
              <svg class="w-2.5 h-2.5" *ngIf="token.priceChange1d >= 0" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="3"><path stroke-linecap="round" stroke-linejoin="round" d="M5 15l7-7 7 7" /></svg>
              <svg class="w-2.5 h-2.5" *ngIf="token.priceChange1d < 0" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="3"><path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" /></svg>
              {{ (token.priceChange1d >= 0 ? token.priceChange1d : -token.priceChange1d) | number:'1.2-2' }}%
            </span>
          </td>
          <td class="py-4 px-4 text-right font-black text-white text-[13px] whitespace-nowrap">
            <span>${{formatNumber(token.fdv || 0)}}</span>
          </td>
          <td class="py-4 px-4 text-right font-black text-white text-[13px] whitespace-nowrap">
            <span>${{formatNumber(token.volume24h || 0)}}</span>
          </td>
        </tr>
        <tr *ngIf="tokens.length === 0 && !loadingTokens">
          <td colspan="7" class="py-12 text-center text-text-muted text-[13px]">
            No tokens found.
          </td>
        </tr>
        <tr *ngIf="tokens.length === 0 && loadingTokens">
          <td colspan="7" class="py-12 text-center text-text-muted text-[13px]">
            Loading...
          </td>
        </tr>
      </tbody>
    </table>

    <!-- POOLS TAB -->
    <table class="w-full text-left border-collapse min-w-[900px]" *ngIf="activeTab === 'Pools'">
      <thead>
        <tr class="text-text-muted text-[11px] font-bold uppercase tracking-wider border-b border-white/5">
          <th class="py-4 px-4 w-12 text-center">#</th>
          <th class="py-4 px-4">Pool</th>
          <th class="py-4 px-4">Protocol</th>
          <th class="py-4 px-4">Fee tier</th>
          <th class="py-4 px-4 text-right">TVL</th>
          <th class="py-4 px-4 text-right">Pool APR</th>
          <th class="py-4 px-4 text-right">1D vol</th>
          <th class="py-4 px-4 text-right">1D vol/TVL</th>
        </tr>
      </thead>
      <tbody class="text-sm">
        <tr *ngFor="let pool of pools; let i = index" [routerLink]="['/liquidity', pool.address]" class="border-b border-white/5 hover:bg-white/[0.04] cursor-pointer transition-colors">
          <td class="py-4 px-4 text-center text-text-muted font-bold text-[12px] whitespace-nowrap">{{i + 1}}</td>
          <td class="py-4 px-4 whitespace-nowrap">
            <div class="flex items-center gap-2 pl-2">
              <div class="flex -space-x-2">
                <img *ngIf="pool.token0.logoUrl" [src]="pool.token0.logoUrl" class="w-6 h-6 rounded-full object-cover border border-[#050505] bg-[#111]" />
                <div *ngIf="!pool.token0.logoUrl" class="w-6 h-6 rounded-full flex items-center justify-center font-black text-white text-[8px] relative overflow-hidden bg-white/10 border border-[#050505] z-10">
                  {{pool.token0.symbol.substring(0, 1)}}
                </div>
                
                <img *ngIf="pool.token1.logoUrl" [src]="pool.token1.logoUrl" class="w-6 h-6 rounded-full object-cover border border-[#050505] bg-[#111]" />
                <div *ngIf="!pool.token1.logoUrl" class="w-6 h-6 rounded-full flex items-center justify-center font-black text-white text-[8px] relative overflow-hidden bg-white/10 border border-[#050505]">
                  {{pool.token1.symbol.substring(0, 1)}}
                </div>
              </div>
              <span class="text-white font-black text-[13.5px]">{{pool.token0.symbol}}/{{pool.token1.symbol}}</span>
            </div>
          </td>
          <td class="py-4 px-4 text-text-muted font-bold text-[12px] whitespace-nowrap">v3</td>
          <td class="py-4 px-4 text-white font-bold text-[12px] whitespace-nowrap">{{ (pool.feeTier / 10000) | number:'1.0-4' }}%</td>
          <td class="py-4 px-4 text-right font-black text-white text-[13px] whitespace-nowrap">${{ formatNumber(pool.tvlUsd || 0) }}</td>
          <td class="py-4 px-4 text-right font-bold text-[12.5px] text-emerald-400 whitespace-nowrap">{{ (pool.apr || 0) | number:'1.2-2' }}%</td>
          <td class="py-4 px-4 text-right font-bold text-[12.5px] text-white whitespace-nowrap">${{ formatNumber(pool.volume24h || 0) }}</td>
          <td class="py-4 px-4 text-right font-bold text-[12.5px] text-text-muted whitespace-nowrap">{{ pool.tvlUsd > 0 ? (pool.volume24h / pool.tvlUsd | number:'1.2-2') : '0.00' }}</td>
        </tr>
        <tr *ngIf="pools.length === 0 && !loadingPools">
          <td colspan="8" class="py-12 text-center text-text-muted text-[13px]">
            No pools found.
          </td>
        </tr>
        <tr *ngIf="pools.length === 0 && loadingPools">
          <td colspan="8" class="py-12 text-center text-text-muted text-[13px]">
            Loading pools...
          </td>
        </tr>
      </tbody>
    </table>

    <!-- TRANSACTIONS TAB -->
    <table class="w-full text-left border-collapse min-w-[800px]" *ngIf="activeTab === 'Transactions'">
      <thead>
        <tr class="text-text-muted text-[12px] font-medium border-b border-white/5">
          <th class="py-4 px-4 w-24">Time</th>
          <th class="py-4 px-4">Type</th>
          <th class="py-4 px-4 text-right">Total Value (USD)</th>
          <th class="py-4 px-4 text-right">Token 0 Amount</th>
          <th class="py-4 px-4 text-right">Token 1 Amount</th>
          <th class="py-4 px-4 text-right">Account</th>
        </tr>
      </thead>
      <tbody class="text-sm">
        <tr *ngFor="let tx of transactions; let i = index" class="border-b border-white/5 hover:bg-white/[0.02] transition-colors group">
          <td class="py-4 px-4 whitespace-nowrap">
            <span class="text-white text-[14px]">{{ formatRelativeTime(tx.time) }}</span>
          </td>
          <td class="py-4 px-4 whitespace-nowrap">
            <span class="font-bold text-[14px]" [ngClass]="tx.type === 'BUY' ? 'text-emerald-400' : (tx.type === 'SELL' ? 'text-red-400' : 'text-blue-400')">{{tx.type}}</span>
          </td>
          <td class="py-4 px-4 text-right whitespace-nowrap">
            <span class="text-white font-medium text-[14px]" *ngIf="tx.usdValue > 0">${{ formatNumber(tx.usdValue) }}</span>
            <span class="text-text-dim text-[14px]" *ngIf="!tx.usdValue || tx.usdValue === 0">-</span>
          </td>
          <td class="py-4 px-4 text-right whitespace-nowrap">
            <span class="text-white text-[14px]">{{ formatNumber(tx.token0Amt) }}</span>
          </td>
          <td class="py-4 px-4 text-right whitespace-nowrap">
            <span class="text-white text-[14px]">{{ formatNumber(tx.token1Amt) }}</span>
          </td>
          <td class="py-4 px-4 text-right whitespace-nowrap">
            <span class="text-[#4C82FB] font-mono text-[14px] hover:text-[#3B72EA] transition-colors">{{tx.wallet.substring(0, 6)}}...{{tx.wallet.substring(tx.wallet.length - 4)}}</span>
          </td>
        </tr>
        <tr *ngIf="transactions.length === 0 && !loadingTransactions">
          <td colspan="6" class="py-12 text-center text-text-muted text-[13px]">
            No transactions found.
          </td>
        </tr>
        <tr *ngIf="transactions.length === 0 && loadingTransactions">
          <td colspan="6" class="py-12 text-center text-text-muted text-[13px]">
            Loading transactions...
          </td>
        </tr>
      </tbody>
    </table>
    </div>
    
    <!-- Pagination -->
    <div class="flex flex-col sm:flex-row justify-between items-center border-t border-white/[0.05] py-4 px-6 gap-4">
      <div class="text-text-muted text-[13px]">
        Showing 
        <ng-container *ngIf="activeTab === 'Tokens'">{{tokens.length > 0 ? (tokensPage - 1) * tokensLimit + 1 : 0}} to {{ (tokensPage - 1) * tokensLimit + tokens.length }} of {{totalTokens}}</ng-container>
        <ng-container *ngIf="activeTab === 'Pools'">{{pools.length > 0 ? (poolsPage - 1) * poolsLimit + 1 : 0}} to {{ (poolsPage - 1) * poolsLimit + pools.length }} of {{totalPools}}</ng-container>
        <ng-container *ngIf="activeTab === 'Transactions'">{{transactions.length > 0 ? (transactionsPage - 1) * transactionsLimit + 1 : 0}} to {{ (transactionsPage - 1) * transactionsLimit + transactions.length }} of {{totalTransactions}}</ng-container>
      </div>
      <div class="flex items-center gap-3">
        <button (click)="changePage(-1)" class="bg-[#050505] hover:bg-gold/10 border border-white/10 hover:border-gold/30 text-white hover:text-gold transition-all duration-300 font-bold text-[13px] px-4 py-2 rounded-xl flex items-center gap-1 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-[#050505] disabled:hover:border-white/10 disabled:hover:text-white"
          [disabled]="(activeTab === 'Tokens' && tokensPage === 1) || (activeTab === 'Pools' && poolsPage === 1) || (activeTab === 'Transactions' && transactionsPage === 1)">
          <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7" /></svg>
          Prev
        </button>
        <div class="text-white text-[13px] font-bold">
          Page 
          <ng-container *ngIf="activeTab === 'Tokens'">{{tokensPage}} of {{maxTokensPage}}</ng-container>
          <ng-container *ngIf="activeTab === 'Pools'">{{poolsPage}} of {{maxPoolsPage}}</ng-container>
          <ng-container *ngIf="activeTab === 'Transactions'">{{transactionsPage}} of {{maxTransactionsPage}}</ng-container>
        </div>
        <button (click)="changePage(1)" class="bg-[#050505] hover:bg-gold/10 border border-white/10 hover:border-gold/30 text-white hover:text-gold transition-all duration-300 font-bold text-[13px] px-4 py-2 rounded-xl flex items-center gap-1 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-[#050505] disabled:hover:border-white/10 disabled:hover:text-white"
          [disabled]="(activeTab === 'Tokens' && tokensPage === maxTokensPage) || (activeTab === 'Pools' && poolsPage === maxPoolsPage) || (activeTab === 'Transactions' && transactionsPage === maxTransactionsPage)">
          Next
          <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M9 5l7 7-7 7" /></svg>
        </button>
      </div>
    </div>
  </div>
  
</section>
